
import Vue, { PropType } from 'vue'
import RPHProductAnalog from 'rph/molecules/RPHProductAnalog/index.vue'

import { IProduct } from 'types/DTO/products'
import { EventsViewedCategory } from '~/enums/eventsViewedCategory'
import RPHProductCard from 'rph/molecules/RPHProductCard/index.vue'

export default Vue.extend({
  name: 'RPHAnalogsGrid',
  components: { RPHProductCard, RPHProductAnalog },
  props: {
    analogs: {
      type: Array as PropType<IProduct[]>,
      default: () => [],
    },
  },
  computed: {
    analogsFirstPart(): Array<IProduct> {
      return this.analogs.length > 5 ? this.analogs.slice(0, 5) : this.analogs
    },
  },

  mounted() {
    this.$services.productsEvents.productViewPushEvent({
      products: this.analogsFirstPart,
      itemListData: {
        item_list_id: EventsViewedCategory.Analogues.id,
        item_list_name: EventsViewedCategory.Analogues.name,
      },
    })
  },
})
